// A URL da API vem de config.js, carregado em runtime pelo <script> no
// <head> do index.html (antes deste módulo) — não mais do build.
//
// Antes disto era decidido em runtime no browser por
// `location.origin.includes('localhost')`: o mesmo bundle servia dev e produção,
// não havia como apontar o debug para outro backend sem editar este arquivo, e
// qualquer host que não fosse localhost caía direto em produção. Depois, passou
// a ser VUE_APP_API_URL embutida no build — o que impedia promover a mesma
// imagem de validação para produção sem reconstruir. VUE_APP_API_URL continua
// como fallback (ambiente de dev fora de container, sem config.js publicado).
const apiUrl = window.__ESTOQUEAUTO_CONFIG__?.apiUrl || process.env.VUE_APP_API_URL;

if (!apiUrl) {
  // Erro de build/configuração, não condição de runtime: melhor aparecer alto.
  throw new Error('URL da API não definida — confira public/config.js ou o .env do modo de build.');
}

export function getEnvironmentUrl() {
  return apiUrl.replace(/\/+$/, '');
}

// Caminhos de arquivo (PathPDF, PathLogo, fotos de avaliação) vêm da API como
// caminhos relativos à raiz — "/nfs/2/nota.pdf". O navegador resolve isso contra
// a origem do FRONT, não da API: o link do PDF abria o próprio sistema em vez de
// baixar o arquivo. Historicamente funcionava porque o mesmo IIS servia a SPA e
// o wwwroot; agora quem entrega esses arquivos é a API (nginx faz proxy de /img
// e /nfs sob o host dela).
export function getFileUrl(path) {
  if (!path) {
    return path;
  }

  // Já absoluto (o backend monta URL completa em alguns pontos) ou data URI de
  // pré-visualização de upload: devolve como está.
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) {
    return path;
  }

  return `${getEnvironmentUrl()}/${String(path).replace(/^\/+/, '')}`;
}
